import CustomDatePicker from "./UtilityComponents/CustomDatePicker";
import { useState, useEffect, useRef } from "react";
import MaskedInput from "react-text-mask";
import Male from "../Investment/Images/Group3635.svg";
import Female from "../Investment/Images/Group3639.svg";
import { calculateAge, getAnnualIncomeList, getMaskForNameWithMaxLength, mobilePattern, getMobileValidationError } from "./UtilityComponents/UtilityFunction";
import { useFormik } from 'formik';
import CustomDropdown from "./UtilityComponents/CustomDropdown";

// Value ko mask karne ka helper (sirf display ke liye, formik value real hi rehti hai)
const maskValue = (fieldName, value) => {
    const val = String(value || "");
    if (!val) return val;

    //if (fieldName === "mob") {
    //    // Last 4 digits dikhao, baaki mask
    //    return val.length > 4 ? "*".repeat(val.length - 4) + val.slice(-4) : val;
    //}

    if (fieldName === "mob") {
        // First 2 aur last 2 digits show, baaki mask
        return val.length > 4
            ? val.slice(0, 2) + "*".repeat(val.length - 4) + val.slice(-2)
            : val;
    }

    if (fieldName === "email") {
        const atIndex = val.indexOf("@");
        if (atIndex <= 0) return "*".repeat(val.length);
        const local = val.slice(0, atIndex);
        const domain = val.slice(atIndex);
        const visible = local.slice(0, Math.min(2, local.length));
        return visible + "*".repeat(Math.max(local.length - visible.length, 0)) + domain;
    }

    if (fieldName === "name") {
        // Har word ka pehla letter dikhao, baaki mask
        return val
            .split(" ")
            .map((word) => (word ? word[0] + "*".repeat(word.length - 1) : word))
            .join(" ");
    }

    return val;
};

function EditSideDetails(props) {
    //console.log(props.email, "email11")

    const [showBtn, setShowBtn] = useState(false);

    // Kaun se fields abhi masked dikh rahe hain
    const [maskedFields, setMaskedFields] = useState({
        name: true,
        mob: true,
        email: true
    });
    // Masked field pe focus aane ke baad real input pe autoFocus dene ke liye
    const focusAfterUnmask = useRef(null);

    const annualIncomeList = getAnnualIncomeList();

    const initialValues = {
        name: props?.name ?? "",
        mob: props?.mob ?? "",
        email: props?.email ?? "testing123@gmail.com",
        income: props?.Income ?? "0",
        DOB: null,
        showBtn: false,
        gender: props.Gender ?? "M",
        IsSmoker: false,
        isChildPlan: props?.QuoteReq?.lifeAssuredDetails?.isChildPlan ?? false,
        ChildName: props.QuoteReq?.lifeAssuredDetails?.FullName ?? '',
        ChildGender: props.QuoteReq?.lifeAssuredDetails?.Gender ?? 'M',
        ChildDOB: props?.QuoteReq?.lifeAssuredDetails?.DOB ? new Date(props?.QuoteReq?.lifeAssuredDetails?.DOB?.split("-")?.reverse()?.join("-")) : '',
        occupation: props.QuoteReq?.Occupation,
        education: props.QuoteReq?.Education,
    }


    const today = new Date();
    let maxDate = new Date(
        today.getFullYear() - 18,
        today.getMonth(),
        today.getDate(),
    )

    let minDate = new Date(
        today.getFullYear() - 65,
        today.getMonth(),
        today.getDate(),
    );

    const childMaxDate = new Date();
    childMaxDate.setDate(today.getDate() - 30);

    // Min date: 13 years ago
    const childMinDate = new Date();
    childMinDate.setFullYear(today.getFullYear() - 13);

    const isMinorAllowedEducation = (educationCode) => {
        if (!educationCode) return false;
        const selectedEducation = props.EducationList?.find(
            (item) => item.Code == educationCode
        );
        const educationName = selectedEducation?.MasterName?.toLowerCase() ?? "";
        return /\b10(th)?\b/.test(educationName) || /\b12(th)?\b/.test(educationName) || educationName.includes("diploma");
    };

    const handleDOBChange = (date) => {
        formik.setFieldValue('DOB', date);
        if (props.QuoteReq?.InvestmentType == "ML") {
            const userAge = calculateAge(date);
            const minorDefaultCode = props.EducationList?.find(
                (item) => item?.Code === "3~12th"
            )?.Code ?? "";
            const adultDefaultCode = props.EducationList?.find(
                (item) => item?.Code === "4~Graduate"
            )?.Code ?? "";

            let nextEducation = formik.values.education;
            if (userAge <= 19 && minorDefaultCode) {
                nextEducation = minorDefaultCode;
                formik.setFieldValue('education', minorDefaultCode);
            }
            if (userAge > 19 && adultDefaultCode) {
                nextEducation = adultDefaultCode;
                formik.setFieldValue('education', adultDefaultCode);
            }

            if (userAge <= 19 && nextEducation && !isMinorAllowedEducation(nextEducation)) {
                formik.setFieldValue('education', '');
                formik.setFieldTouched('education', true, false);
                formik.setFieldError('education', 'Please select valid education');
            } else {
                formik.setFieldError('education', undefined);
            }
        }
        if (props.onDobChange && date && !isNaN(new Date(date))) {
            const selectedDob = new Date(date).toISOString().split("T")[0].split("-").reverse().join("-");
            props.onDobChange(selectedDob);
        }
    }

    const normalizeEmail = (email) => String(email || "").trim().toLowerCase();
    const validateEmail = (email) => {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}(\.[0-9]{1,3}){3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email.trim());
    };

    function updatehandler() {
        const { name, mob, email, DOB, gender, income, IsSmoker, occupation, education } = formik.values;

        let userAge = calculateAge(DOB);
        const db = DOB.toISOString().split("T")[0]?.split("-").reverse().join("-")
        let model = {
            FullName: name,
            AnnualIncome: income,
            DOB: db,
            MobileNo: mob,
            Email: email,
            Age: userAge,
            gender,
            IsSmoker,
            Occupation: occupation,
            Education: education
        }


        props.onsubmit(model);
        props.exit();
    }



    const validate = (values) => {

        const { name, mob, email, DOB, gender, income, IsSmoker, isChildPlan, ChildName, ChildDOB } = values;
        let error = {};
        let goto = true;
        if (income === '') {
            error['income'] = "Please select annual income";
            goto = false;
        }
        if (name.trim() === '') {
            error['name'] = "Please enter name";
            goto = false;
        }
        else if (name.trim().length < 2) {
            error["name"] = "Please enter valid name";
            goto = false;
        }
        /*else if (Name.trim().length>50) {
            error["Name"] = "Please enter name 2 to 50 characters";
            goto = false;
        }*/

        /*else if (name.trim().split(" ").length < 2) {
            error["name"] = "Please enter full name";
            goto = false;
        }*/
        //if (!mob) {
        //    goto = false;
        //    error["mob"] = "Please enter valid mobile number"
        //}
        //else if (mob !== null) {
        //    if (mob.length < 10) {
        //        goto = false;
        //        error["mob"] = "Entered mobile number should be of 10 digits"
        //    }
        //    else if (mob === "9999999999" || mob === "8888888888" || mob === "7777777777" || mob === "6666666666") {
        //        goto = false;
        //        error["mob"] = "Please enter valid mobile number"
        //    } else if (mobilePattern.test(mob)) {
        //        goto = false;
        //        error["mob"] = "First 6 digits cannot be all the same"
        //    }
        //}

        /*if (!values.mob) {
            error["mob"] = "Please enter valid mobile number";
        } else if (values.mob.length !== 10) {
            error["mob"] = "Entered mobile number should be of 10 digits";
        } else {
            const mobileError = getMobileValidationError(values.mob);
            if (mobileError) {
                error["mob"] = mobileError;
            }
        }*/

        if (values.mob) {
            if (values.mob.length !== 10) {
                error["mob"] = "Entered mobile number should be of 10 digits";
            } else {
                const mobileError = getMobileValidationError(values.mob);
                if (mobileError) {
                    error["mob"] = mobileError;
                }
            }
        }


        if (!normalizeEmail(email)) {
            error["email"] = "Please enter email address";
            goto = false;
        } else if (!validateEmail(email)) {
            error["email"] = "Please enter valid email";
            goto = false;
        }
        if (values?.isChildPlan) {
            if (values?.ChildName?.trim() === "") {
                error["ChildName"] = "Please enter name";
            }
            else if (values?.ChildName?.trim()?.length < 2) {
                error["ChildName"] = "Please enter valid name";
            }
            if (values?.ChildDOB === "" || values?.ChildDOB === "Date of birth") {
                error["ChildDOB"] = "Select a date";
            }
        }

        if (props.QuoteReq?.InvestmentType == "ML") {
            if (values?.occupation === "") {
                error["occupation"] = "Please select occupation";
            }
            if (values?.education === "") {
                error["education"] = "Please select education";
            } else if (calculateAge(values?.DOB) <= 19 && !isMinorAllowedEducation(values?.education)) {
                error["education"] = "Please select valid education";
            }
        }

        //setError(error);

        return error;
    }

    const formik = useFormik({
        initialValues,
        validate,
        onSubmit: () => {
            updatehandler()
        }
    })

    useEffect(() => {
        // setDOB(new Date(props.DOB?.split("-").reverse().join("-")));
        formik.setFieldValue('DOB', new Date(props.DOB?.split("-").reverse().join("-")));
        //setSmoker(props?.IsSmoker);
        formik.setFieldValue('IsSmoker', props?.IsSmoker);
    }, [])

    useEffect(() => {
        if (props.QuoteReq?.InvestmentType !== "ML") return;
        if (!formik.values.DOB || !props.EducationList || props.EducationList.length === 0) return;

        const userAge = calculateAge(formik.values.DOB);
        const minorDefaultCode = props.EducationList?.find(
            (item) => item?.Code === "3~12th"
        )?.Code ?? "";
        const adultDefaultCode = props.EducationList?.find(
            (item) => item?.Code === "4~Graduate"
        )?.Code ?? "";

        if (userAge <= 19 && minorDefaultCode && formik.values.education !== minorDefaultCode) {
            formik.setFieldValue('education', minorDefaultCode);
            formik.setFieldError('education', undefined);
        }
        if (userAge > 19 && adultDefaultCode && formik.values.education !== adultDefaultCode) {
            formik.setFieldValue('education', adultDefaultCode);
            formik.setFieldError('education', undefined);
        }
    }, [formik.values.DOB, props.EducationList, props.QuoteReq?.InvestmentType]);


    useEffect(() => {
        const { name, mob, email, DOB, gender, income, IsSmoker, ChildDOB, ChildGender, ChildName, isChildPlan, education, occupation } = formik.values;
        const formattedChildDOB =
            ChildDOB && !isNaN(new Date(ChildDOB)) // check if it's a valid date
                ? new Date(ChildDOB).toISOString().split("T")[0]
                : "";

        const formattedDOB =
            props.QuoteReq?.lifeAssuredDetails?.DOB
                ?.split("-")
                ?.reverse()
                ?.join("-");

        if (name !== props.name || (mob || "") !== (props.mob || "") || email !== props.email || income !== props.Income || DOB?.toISOString().split("T")[0] !== props.DOB?.split("-").reverse().join("-") || gender !== props.Gender || IsSmoker !== props.IsSmoker || occupation !== props.QuoteReq.Occupation || education !== props.QuoteReq.Education) {
            setShowBtn(true);
        }
        else {
            setShowBtn(false);
        }
    }, [formik.values.name, formik.values.mob, formik.values.email, formik.values.income, formik.values.DOB, formik.values.gender, formik.values.IsSmoker, formik.values.education, formik.values.occupation])

    // ---------- Masking helpers ----------

    // Field masked tabhi dikhega jab flag on ho aur value empty na ho
    const isMasked = (fieldName) => maskedFields[fieldName] && !!formik.values[fieldName];

    // Blur par: touched mark karo, aur value valid hai to mask on kar do
    const handleFieldBlur = (e) => {
        const fieldName = e.target.name;
        formik.handleBlur(e);
        focusAfterUnmask.current = null;

        const fieldError = validate(formik.values)[fieldName];
        if (formik.values[fieldName] && !fieldError) {
            setMaskedFields((prev) => ({ ...prev, [fieldName]: true }));
        }
    };

    // Masked input pe focus/click aaye to mask hata do aur real input pe focus bhejo
    const unmaskField = (fieldName) => {
        focusAfterUnmask.current = fieldName;
        setMaskedFields((prev) => ({ ...prev, [fieldName]: false }));
    };

    // Masked (display-only) input
    const renderMasked = (fieldName, extraClass = "") => (
        <input
            type="text"
            className={`inputText packageForm ${extraClass}`.trim()}
            name={fieldName}
            readOnly
            placeholder=" "
            value={maskValue(fieldName, formik.values[fieldName])}
            onFocus={() => unmaskField(fieldName)}
            onClick={() => unmaskField(fieldName)}
        />
    );


    return (
        <>
            <div className="EditProduct EditSideDetails">
                <div className="EditProductHead EditDetails">
                    <h1>Edit Details</h1>
                    <button type="button" className="clsBtn" data-dismiss="modal" onClick={props.exit}>
                        <img src={require("../Investment/Cross.svg").default} alt="" />
                    </button>
                </div>

                <div className="EditDetailsBody InvstrDetails">
                    <div className="PersonalDetails">
                        <div className="RDType Gender">
                            <span className="RDText">Gender</span>
                            {/*<input className="RDInput" onChange={(e) => setGender("M")} name="Gender" type="radio"  checked={gender==="M"} />Male
                                <input className="RDInput" onChange={(e) => setGender("F")} name="Gender" type="radio"  checked={gender==="F"} />Female*/}
                            <div className="form-check-inline">
                                <div className="radio-item">
                                    <input
                                        type="radio"
                                        id="ritema"
                                        name="gender"
                                        value="M"
                                        checked={formik.values.gender === "M"}
                                        onChange={() => formik.setFieldValue('gender', 'M')}
                                    />
                                    <label htmlFor="ritema">
                                        {" "}
                                        <img alt="" src={Male} className="IconPic" /> Male{" "}
                                    </label>
                                </div>
                                <div className="radio-item">
                                    <input
                                        type="radio"
                                        id="ritemb"
                                        name="gender"
                                        value="F"
                                        checked={formik.values.gender === "F"}
                                        onChange={() => formik.setFieldValue('gender', 'F')}
                                    />
                                    <label htmlFor="ritemb">
                                        {" "}
                                        <img alt="" src={Female} className="IconPic" /> Female{" "}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ---------- Full Name ---------- */}
                    <div className="PersonalDetails">
                        <span className="PDLabel">Full Name</span>

                        {isMasked("name") ? (
                            renderMasked("name", "text-capitalize")
                        ) : (
                            <MaskedInput
                                className="inputText packageForm text-capitalize"
                                mask={getMaskForNameWithMaxLength(50)}
                                guide={false}
                                showMask={false}
                                autoFocus={focusAfterUnmask.current === "name"}
                                placeholder=" "
                                {...formik.getFieldProps('name')}
                                name="name"
                                onKeyDown={(e) => {
                                    // Prevent typing multiple consecutive spaces
                                    const { value, selectionStart } = e.target;
                                    if (e.key === ' ' && (selectionStart === 0 || value[selectionStart - 1] === ' ')) {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    // Ensure no leading spaces or multiple spaces
                                    const processedValue = e.target.value
                                        .replace(/^\s+/, '') // Remove leading spaces
                                        .replace(/\s{2,}/g, ' '); // Replace multiple spaces with a single space
                                    // setName(processedValue);
                                    formik.setFieldValue('name', processedValue)
                                }}
                                onBlur={handleFieldBlur}
                            />
                        )}
                        {formik.touched.name && formik.errors.name ? <span className="Error_Text">{formik.errors["name"]}</span> : null}
                    </div>
                    <div className="PersonalDetails">
                        <CustomDatePicker onDateSelection={handleDOBChange} maxDate={maxDate} minDate={minDate} selectedDate={formik.values.DOB} />
                        <span className="DOBTextLabel PDLabel handCursor">Date of Birth</span>
                        <small className="UserAge"><b>{calculateAge(formik.values.DOB)} years</b></small>
                        {formik.touched.DOB && formik.errors.DOB ? <span className="Error-Text">{formik.errors['DOB']}</span> : null}
                    </div>
                    <div className="PersonalDetails annualIncomeBox">
                        <span className="InvestAnnualIncome PDLabel">Approx. Annual Income</span>
                        <CustomDropdown
                            options={annualIncomeList}
                            value={formik.values.income}
                            labelKey="name"
                            valueKey="code"
                            placeholder="Select Income"
                            onChange={(data) => formik.setFieldValue("income", data.code)}
                        />

                        {/*<select
                            className="packageForm"
                            defaultValue="1500000"
                            name="income"
                            {...formik.getFieldProps('income')}
                        >
                            <option value="">Select Income</option>
                            <option value="100000">1 Lakh</option>
                            <option value="200000">2 Lakh</option>
                            <option value="300000">3 Lakh</option>
                            <option value="400000">4 Lakh</option>
                            <option value="500000">5 Lakh</option>
                            <option value="600000">6 Lakh</option>
                            <option value="700000">7 Lakh</option>
                            <option value="800000">8 Lakh</option>
                            <option value="900000">9 Lakh</option>
                            <option value="1000000">10 Lakh</option>
                            <option value="1100000">11 Lakh</option>
                            <option value="1200000">12 Lakh</option>
                            <option value="1300000">13 Lakh</option>
                            <option value="1400000">14 Lakh</option>
                            <option value="1500000">15 Lakh</option>
                            <option value="1600000">16 Lakh</option>
                            <option value="1700000">17 Lakh</option>
                            <option value="1800000">18 Lakh</option>
                            <option value="1900000">19 Lakh</option>
                            <option value="2000000">20 Lakh</option>
                            <option value="2100000">21 Lakh</option>
                            <option value="2200000">22 Lakh</option>
                            <option value="2300000">23 Lakh</option>
                            <option value="2400000">24 Lakh</option>
                            <option value="2500000">25 Lakh</option>
                        </select>*/}
                        {formik.touched.income && formik.errors.income ? <span className="Error_Text2">{formik.errors["income"]}</span> : null}
                    </div>
                    <div className="PersonalDetails">
                        <div className="RDType Smoking">
                            <span className="RDText">Are you smoking?</span>
                            {/*<input className="RDInput" onChange={(e) => setSmoker(true)} name="Smoker" type="radio" checked={IsSmoker} />Yes
                                <input className="RDInput" onChange={(e) => setSmoker(false)} name="Smoker" type="radio" checked={!IsSmoker} />No*/}
                            <div className="form-check-inline ">
                                <div className="radio-item">
                                    <input
                                        type="radio"
                                        id="ritemy"
                                        name="IsSmoker"
                                        value="Y"
                                        checked={formik.values.IsSmoker}
                                        onChange={() => formik.setFieldValue('IsSmoker', true)}
                                    />
                                    <label htmlFor="ritemy">
                                        {" "}
                                        Yes{" "}
                                    </label>
                                </div>
                                <div className="radio-item">
                                    <input
                                        type="radio"
                                        id="ritemn"
                                        name="IsSmoker"
                                        value="N"
                                        checked={!formik.values.IsSmoker}
                                        onChange={() => formik.setFieldValue('IsSmoker', false)}
                                    />
                                    <label htmlFor="ritemn">
                                        {" "}
                                        No{" "}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ---------- Mobile Number ---------- */}
                    <div className="PersonalDetails mobFloat">
                        <span className="mobLabel">Mobile Number</span>
                        {isMasked("mob") ? (
                            renderMasked("mob")
                        ) : (
                            <MaskedInput
                                className="inputText packageForm"
                                mask={[
                                    /[6-9]/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                ]}
                                guide={false}
                                showMask={false}
                                autoFocus={focusAfterUnmask.current === "mob"}
                                name="mob"
                                placeholder=" "
                                maxLength="10"
                                {...formik.getFieldProps('mob')}
                                onBlur={handleFieldBlur}
                            />
                        )}
                        {formik.touched.mob && formik.errors.mob ? <span className="Error_Text">{formik.errors["mob"]}</span> : null}
                    </div>

                    {/* ---------- Email ---------- */}
                    {/*<div className="PersonalDetails">
                        <span className="PDLabel">Email Address</span>
                        {isMasked("email") ? (
                            renderMasked("email")
                        ) : (
                            <input
                                type="text"
                                className="inputText packageForm"
                                name="email"
                                placeholder=" "
                                maxLength={100}
                                autoFocus={focusAfterUnmask.current === "email"}
                                {...formik.getFieldProps('email')}
                                onChange={(e) => {
                                    const cleaned = e.target.value.replace(/[<>()\[\]\\,;:*&^%#$!~`+=_\-'"\/\s]/g, "");
                                    formik.setFieldValue("email", cleaned);
                                }}
                                onBlur={handleFieldBlur}
                            />
                        )}
                        {formik.touched.email && formik.errors.email ? <span className="Error_Text">{formik.errors["email"]}</span> : null}
                    </div>*/}

                    {/*  <div className="RDType Gender mb-2">
                        <span className="RDText">Do you want child plan ?</span>
                        <div className="form-check-inline">
                            <div className="radio-item">
                                <input
                                    type="radio"
                                    id="child"
                                    name="isChildPlan"
                                    value={true}
                                    checked={formik.values.isChildPlan}
                                    onChange={() => formik.setFieldValue('isChildPlan', true)}
                                />
                                <label for="child">
                                    Yes
                                </label>
                            </div>
                            <div className="radio-item">
                                <input
                                    type="radio"
                                    id="childb"
                                    name="isChildPlan"
                                    value={false}
                                    checked={!formik.values.isChildPlan}
                                    onChange={() => formik.setFieldValue('isChildPlan', false)}
                                />
                                <label for="childb">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>

                    {formik.values.isChildPlan &&
                        <>
                    <div className="PersonalDetails">
                        <span className="PDLabel">Child Name</span>

                        <MaskedInput
                            className="inputText packageForm text-capitalize"
                            mask={getMaskForNameWithMaxLength(50)}
                            guide={false}
                            showMask={false}
                            onKeyDown={(e) => {
                                // Prevent typing multiple consecutive spaces
                                const { value, selectionStart } = e.target;
                                if (e.key === ' ' && (selectionStart === 0 || value[selectionStart - 1] === ' ')) {
                                    e.preventDefault();
                                }
                            }}
                            onChange={(e) => {
                                // Ensure no leading spaces or multiple spaces
                                const processedValue = e.target.value
                                    .replace(/^\s+/, '') // Remove leading spaces
                                    .replace(/\s{2,}/g, ' '); // Replace multiple spaces with a single space
                                // setName(processedValue);
                                formik.setFieldValue('ChildName', processedValue)
                            }}
                            placeholder=" "
                            {...formik.getFieldProps('ChildName')}
                                name="ChildName"
                        />
                        {formik.touched.ChildName && formik.errors.ChildName ? <span className="Error-Text">{formik.errors["ChildName"]}</span> : null}
                    </div>

                    <div className="PersonalDetails">

                        <span className="DOBText">Child Date of Birth</span>
                        <CustomDatePicker onDateSelection={(date) => formik.setFieldValue('ChildDOB', date)} {...formik.getFieldProps('ChildDOB')} maxDate={childMaxDate} minDate={childMinDate} selectedDate={formik.values.ChildDOB} />
                        {formik.touched.ChildDOB && formik.errors.ChildDOB ? <span className="Error-Text">{formik.errors["ChildDOB"]}</span> : null}
                        {formik?.values?.ChildDOB && <small className="UserAge"><b>{calculateAge(formik?.values?.ChildDOB)} {calculateAge(formik?.values?.ChildDOB) > 1 ? "Years" : "Year"}</b></small>}
                    </div>

                    <div className="PersonalDetails">
                        <div className="RDType Gender">
                            <span className="RDText">Child Gender</span>
                            */}{/*<input className="RDInput" onChange={(e) => setGender("M")} name="Gender" type="radio"  checked={gender==="M"} />Male
                                <input className="RDInput" onChange={(e) => setGender("F")} name="Gender" type="radio"  checked={gender==="F"} />Female*/}{/*
                            <div className="form-check-inline">
                                <div className="radio-item">
                                    <input
                                        type="radio"
                                        id="cgend"
                                        name="ChildGender"
                                        value="M"
                                        checked={formik.values.ChildGender === "M"}
                                        onChange={() => formik.setFieldValue('ChildGender', 'M')}
                                    />
                                        <label for="cgend">
                                        {" "}
                                        <img alt="" src={Male} className="IconPic" /> Male{" "}
                                    </label>
                                </div>
                                <div className="radio-item">
                                    <input
                                        type="radio"
                                        id="cgendb"
                                        name="ChildGender"
                                        value="F"
                                        checked={formik.values.ChildGender === "F"}
                                        onChange={() => formik.setFieldValue('ChildGender', 'F')}
                                    />
                                    <label for="cgendb">
                                        {" "}
                                        <img alt="" src={Female} className="IconPic" /> Female{" "}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    </>}*/}

                    {props.QuoteReq.InvestmentType == "ML" && <div className="mt-5">
                        <div className="PersonalDetails annualIncomeBox">
                            <span className="InvestAnnualIncome PDLabel">Education</span>
                            <select
                                className="packageForm mb-3"
                                defaultValue="1500000"
                                name="education"
                                {...formik.getFieldProps('education')}
                            >
                                <option value="">Select Education</option>
                                {props.EducationList?.map((item) => <option value={item.Code}>{item.MasterName}</option>)}
                            </select>
                            {formik.touched.education && formik.errors.education ? <span className="Error_Text2">{formik.errors["education"]}</span> : null}
                        </div>

                        <div className="PersonalDetails annualIncomeBox">
                            <span className="InvestAnnualIncome PDLabel">Occupation</span>
                            <select
                                className="packageForm mb-3"
                                defaultValue="1500000"
                                name="occupation"
                                {...formik.getFieldProps('occupation')}
                            >
                                <option value="">Select Occupation</option>
                                {props.OccupationList?.map((item) => <option value={item.Code}>{item.MasterName}</option>)}
                            </select>
                            {formik.touched.occupation && formik.errors.occupation ? <span className="Error_Text2">{formik.errors["occupation"]}</span> : null}
                        </div>
                    </div>}

                </div>

                <div className="EditDetailsFooter">
                    <label className="m-0 w-100">
                        <button className={showBtn ? "UpdateBtn" : "disableBtn"} disabled={showBtn ? false : true} onClick={formik.handleSubmit} >
                            Submit
                        </button>
                    </label>
                </div>


            </div>
        </>
    );
};


export default EditSideDetails;